import React, { useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import { setPageId } from '../services/Metrics'
import { session } from '../load-config'

function TrackingPage(page, pageId, checkSessionId = true) {

  return (props) => {
    return (
      <TrackingPageComponent WrappedComponent={page} pageId={pageId} checkSessionId={checkSessionId} {...props} />
    )
  }
}

export default TrackingPage


function TrackingPageComponent(props) {
  const { WrappedComponent, pageId, checkSessionId } = props

  useEffect(() => {
    if (pageId) {
      setPageId({ pageId })
    }
  }, [])

  function handleSetPageId(id) {
    setPageId({ pageId: id })
  }
  
  return !checkSessionId || (checkSessionId && session.getSessionId()) ? (
    <WrappedComponent setPageId={handleSetPageId} {...props} />
  ) : <Redirect to="/" />
}
